// extracted by mini-css-extract-plugin
var _1 = "TooltipStyle-module__title___AlFuM";
var _2 = "TooltipStyle-module__tooltip___PdTB5";
export { _1 as "title", _2 as "tooltip" }
